import { render } from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=template&id=de36883c&scoped=true"
import script from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=style&index=0&id=de36883c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de36883c"]])

export default __exports__